import {
  createHttpLink,
  InMemoryCache,
  TypePolicies,
  ApolloClient,
  ApolloClientOptions,
  NormalizedCacheObject,
} from '@apollo/client';
import {Header} from '@shopify/react-network';
import {authenticatedFetch} from '@shopify/app-bridge/utilities';
import {appBridge} from 'packages/app-bridge';
import {getSerialized} from 'utilities/server-data';

import possibleTypes from '../../../graphql/default-schema-possible-types.json';

export const SAME_SITE_HEADER = 'x-shopify-react-xhr';
export const SAME_SITE_VALUE = '1';

export const typePolicies: TypePolicies = {
  QueryRoot: {
    queryType: true,
    fields: {
      onlineStore: {merge: true},
      shop: {merge: true},
    },
  },
  Shop: {
    fields: {
      features: {merge: true},
    },
  },
  Preview: {
    keyFields: ['urlWithPasswordBypass'],
  },
};

const {locale} = getSerialized();

const cache = new InMemoryCache({
  possibleTypes,
  typePolicies,
});

const url = new URL(window.location.href);

export const createClientOptions: () => ApolloClientOptions<NormalizedCacheObject> =
  () => {
    const httpLinkOptions: {[key: string]: any} = {
      uri: `${url.origin}/graphql`,
      credentials: 'include',
      headers: {
        [Header.AcceptLanguage]: locale,
        [SAME_SITE_HEADER]: SAME_SITE_VALUE,
      },
      fetch: authenticatedFetch(appBridge, fetch),
    };

    const link = createHttpLink(httpLinkOptions);

    return {link, cache, ssrMode: false};
  };

export const client = new ApolloClient(createClientOptions());
